import { omit } from 'lodash';
import { FETCH_PURCHASE_PROJECTION } from '../actions/index';
import { normalizePurchase } from './schemas';

const extractPurchase = (action) => {
  const { payload } = action;
  const { id } = payload;

  if (!id) return;

  const normalized = normalizePurchase(omit(payload, 'namespace'));
  return normalized.entities.purchases[normalized.result];
};

const setMembershipsFromPurchase = (action) => {
  const { payload } = action;
  const { entities: { memberships } } = normalizePurchase(payload);

  return { ...memberships };
};

export default (state = {}, action) => {
  if (action.type !== FETCH_PURCHASE_PROJECTION) return state;
  if (!action.payload.namespace) return state;

  return {
    ...state,
    [action.payload.namespace]: {
      purchase: extractPurchase(action),
      memberships: setMembershipsFromPurchase(action),
    },
  };
};



// WEBPACK FOOTER //
// ./src/reducers/projections.reducer.js